// Release edit dialog templates for hide-duration and history date controls.
import { t } from '../../../shared/config/translations'
import { localCalendarDate } from '../../../shared/utils/calendarDate'
import { renderDateField } from '../inputs/dateFieldTemplates'
import { renderSelect } from '../inputs/selectTemplates'
import { hideDurationOptionsTemplate } from './releaseDialogOptionTemplates'

/** Renders the edit dialog body for hide-duration and a unified editable listening history. */
export function releaseEditDialogContentTemplate(
	initialHideDurationMonths: number | 'forever' | null,
): string {
	const today = localCalendarDate()

	return `
      ${renderSelect({
			label: t('release.hideFor'),
			labelPlacement: 'outside',
			options: hideDurationOptionsTemplate(initialHideDurationMonths),
			selectId: 'edit-hide-duration',
			inputClass: 'tt-input',
		})}
      <section class="edit-history" aria-labelledby="edit-history-heading">
        <div class="edit-history-heading">
          <h3 id="edit-history-heading">${t('release.listeningHistory')}</h3>
          <button type="button" id="edit-remove-all" class="btn noFrame small">${t('release.removeAllHistory')}</button>
        </div>
        <div class="edit-history-add">
          ${renderDateField({
				inputId: 'edit-add-date',
				label: t('release.addDate'),
				labelPlacement: 'outside',
				inputClass: 'tt-input',
				inputAttrs: { value: today, max: today },
			})}
          <button type="button" id="edit-add-date-btn" class="btn primary">${t('dialog.add')}</button>
        </div>
        <p class="edit-history-empty f secondary">${t('release.emptyHistory')}</p>
        <ul class="edit-history-list"></ul>
        <p class="edit-history-hint f secondary">${t('release.historySaveHint')}</p>
      </section>
  `
}
